// These are used as the key to store GroupBy setting for
// each user. Changing the string will break people's
// stored setting.
export enum TaskboardGroupBy {
    PARENT_CLASSIFICATION = "requirements",
    PEOPLE_CLASSIFICATION = "people"
}